import React from "react";

import Localization from "../Localization";
import CountrySelect from "./CountrySelect";

import "./styles.scss";

import capacity from "../images/capacity.png";
import status from "../images/status.png";
import technology from "../images/technology.png";
//import co2Emissions from "../images/co2Emissions.png";
import lender from "../images/lender.png";
import dealType from "../images/dealType.png";

const navOptions = {
  view: [
    {
      key: "overview",
      label: () => <div>{Localization.get("Overview")}</div>,
    },
    {
      key: "comparison",
      label: () => <div>{Localization.get("Multi-Attribute Comparison")}</div>,
    },
  ],
  metric: [
    {
      key: "capacity",
      label: () => (
        <div className="metricLabel">
          <img src={capacity} alt="" />
          <div>{Localization.get("Capacity")}</div>
        </div>
      ),
    },
    {
      key: "status",
      label: () => (
        <div className="metricLabel">
          <img src={status} alt="" />
          <div>{Localization.get("Status")}</div>
        </div>
      ),
    },
    {
      key: "technology",
      label: () => (
        <div className="metricLabel">
          <img src={technology} alt="" />
          <div>{Localization.get("Technology")}</div>
        </div>
      ),
    },
    // {
    //   key: 'co2emissions',
    //   label: () => (
    //     <div className='metricLabel'>
    //       <img src={co2Emissions} alt='' />
    //       <div>
    //         co<sub>2</sub>{` ${Localization.get('Emissions')}`}
    //       </div>
    //     </div>
    //   ),
    // },
    {
      key: "lender",
      label: () => (
        <div className="metricLabel">
          <img src={lender} alt="" />
          <div>{Localization.get("Lender")}</div>
        </div>
      ),
    },
    {
      key: "dealtype",
      label: () => (
        <div className="metricLabel">
          <img src={dealType} alt="" />
          <div>{Localization.get("Deal Type")}</div>
        </div>
      ),
    },
  ],
  geoType: [
    {
      key: "countries",
      label: () => <span>{Localization.get("Countries")}</span>,
    },
    {
      key: "regions",
      label: () => <span>{Localization.get("Regions")}</span>,
    },
  ],
};

function Selector(props) {
  const { type, selected, update } = props;
  return (
    <div className={`Selector ${type}`}>
      {navOptions[type].map((o) => (
        <div
          key={o.key}
          className={`option ${type} ${o.key === selected ? "active" : ""}`}
          onClick={() => update(o.key)}
        >
          {o.label()}
        </div>
      ))}
    </div>
  );
}

export default function Navigation(props) {
  return (
    <div className="Navigation">
      <div className="topLevel">
        <div className="title">
          <h1>{Localization.get("China’s Global Power Database")}</h1>
          {/* <h2>
            {Localization.get('China’s Foreign Direct Investment and Development Finance in Power Generation Overseas')}
          </h2> */}
        </div>
        <Selector type="view" selected={props.view} update={props.setView} />
        <div className="spacer" />
      </div>
      {props.view === "overview" ? (
        <div className="overviewControls">
          <Selector
            type="metric"
            selected={props.metric}
            update={props.setMetric}
          />
          <Selector
            type="geoType"
            selected={props.geoType}
            update={(value) => props.updateGeo("type", value)}
          />
          <div className="selectWrapper">
            <CountrySelect
              language={props.language}
              countries={props[props.geoType]}
              value={props.geoSelection}
              onChange={(c) => {
                const value = c === "ALL" ? "" : c;
                props.updateGeo("selection", value);
              }}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}
